<template>
    <div class="container">
        <p>Log off being processed...</p>
    </div>
</template>

<style scoped lang="scss">
    .container {
        padding-top:3em;
        font-size:1.4rem;
    }
</style>

<script lang="ts">
import { identity } from "@/identity";

import { defineComponent } from "vue";
import PageBase from "@/shared/components/common/PageBase";

export default defineComponent({
    name: "AccountLogoff",
    extends: PageBase,
    mounted(): void {
        identity.signOut();
    }
});

</script>
